// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/value-proposition-list/value-proposition-list.component.scss
// module id = 763
// module chunks = 0